export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-male-symbol-424c7f92f7d4f3df58f0e89cbad5aebb.svg";